module.exports = __webpack_public_path__ + "img/messages.4079c825.svg";